export const resolveTimerUpNextPhase = ({ phases, currentPhaseIndex } = {}) => {
  if (!Array.isArray(phases) || !Number.isInteger(currentPhaseIndex)) {
    return null;
  }

  if (!phases[currentPhaseIndex]) {
    return null;
  }

  return phases[currentPhaseIndex + 1] || null;
};

export const getTimerUpNextDisplay = (phase) => {
  if (!phase) {
    return {
      title: 'Workout complete',
      badge: '',
    };
  }

  if (phase.type === 'rest') {
    const duration = Number.isFinite(phase.duration) ? Math.max(0, Math.round(phase.duration)) : 0;
    return {
      title: 'Rest',
      badge: duration > 0 ? `${duration}s` : '',
    };
  }

  return {
    title: phase.exerciseName || 'Workout',
    badge: phase.reps || '',
  };
};
